import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {FieldService} from '../../services/FieldService';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-checkbox',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Button,
    InputText
  ],
  template: `
    @if (fieldsvc.ShowAddOptions(field)) {
      <div class="form-row">
        <label >{{ Yii.t('app', 'Field Options:' )}}</label>
        <div >
          @for (option of field.field_options; track option.option_id) {
            <div class="flex-row gap-4px flex-align-center" style="margin-bottom: 4px">
              <span class="text-danger">*</span>
              <input
                pInputText
                size="small"
                [(ngModel)]="option.option_title"
                [placeholder]="(option.option_title)? option.option_title : 'Option-'+(option.option_id+1)"
                (change)="fieldsvc.OnFieldChanged.emit(field)"
                style="width: 70%;">
              @if (field.calculate_by_additional_val && (field.field_type =='radio' || field.field_type =='dropdown')) {
                <input
                  pInputText
                  size="small"
                  type="number"
                  [(ngModel)]="option.option_additional_value"
                  placeholder="Numeric Val"
                  (change)="fieldsvc.OnFieldChanged.emit(field)"
                  style="width: 10%;"/>
              }
              @if (!option.predefined) {
                <p-button
                  size="small"
                  icon="fa fa-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (click)="fieldsvc.DeleteOption(field, option)"
                />
              }
              <span>{{ Yii.t('app', 'Value:')}}{{ option.option_value }};&nbsp; id= {{option.option_id}}</span>
            </div>
          }
          <p-button
            (click)="fieldsvc.AddOption(field)"
            [label]="Yii.t('app', 'Add Option')"
            icon="fa fa-plus"
            size="small"
          />
        </div>
      </div>
    }
  `
})
export class FieldCheckbox {
  Yii = Yii;
  @Input() field: any;

  constructor(public fieldsvc: FieldService) {
  }
}
